import React, { Component } from 'react'
import {Link, BrowserRouter, Switch, Route, withRouter} from 'react-router-dom'
import { Button, Icon } from 'semantic-ui-react'
import DeleteModal from '../modalComponent/deleteFile'
import EditModal from '../modalComponent/EditModal'
import DeleteAxios from '../axiosComponent/deleteAxios'
import ApproveRejectForm from './insertTransporter'

export default class ApproveButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id : props.data.id,
            path : "/reviewTransporter?"+props.data.id
        }
    }
    render() {
    return (
        <center><Button href={this.state.path} id={this.state.id} basic size="mini" type="button" icon> <Icon name="eye" color="green" /></Button></center>

    )
    }
}

